var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgAddImage = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 11.342v.806C2 13.171 2.83 14 3.852 14h5.537a4.027 4.027 0 0 1 0-1.333h-3.38L10.3 7l2.367 2.282v.106a4.027 4.027 0 0 1 1.333 0V3.852C14 2.829 13.171 2 12.148 2H3.852C2.829 2 2 2.83 2 3.852v7.49Zm1.852-8.009a.519.519 0 0 0-.519.519v5.58l1.48-1.848a.667.667 0 0 1 .96-.085L7.26 8.806l2.43-3.209a.667.667 0 0 1 .995-.077l1.982 1.911v-3.58a.519.519 0 0 0-.519-.518H3.852Zm2.601 6.538-1.035-.91-2.085 2.606v.581c0 .287.233.519.519.519h.483L6.453 9.87Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 12.667v-1.334a.667.667 0 0 0-1.333 0v1.334h-1.334a.667.667 0 1 0 0 1.333h1.334v1.333a.667.667 0 0 0 1.333 0V14h1.333a.667.667 0 0 0 0-1.333H14Z"
  }))));
});
SvgAddImage.displayName = "SvgAddImage";
export default SvgAddImage;